import { core } from '@tock/coretypes';
import { findIndex } from 'es-toolkit/compat';

const NUM_TICKET_COLORS = 15;

export function getColorOfTicketTypeId(
  allActiveTickets: core.TicketType[],
  ticketTypeId: number
): string {
  const ticketIndex = findIndex(allActiveTickets, { id: ticketTypeId });
  return ticketIndex === -1
    ? 'SquareColor--archived'
    : `SquareColor--${(ticketIndex % NUM_TICKET_COLORS) + 1}`;
}
